var _style, _feBlend, _feBlend2, _mask, _path, _path2, _path3, _path4, _g, _rect, _rect2, _rect3, _rect4, _rect5, _path5, _feBlend3, _feBlend4, _mask2, _path6, _path7, _path8, _rect6, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWordpressRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "800px",
    height: "515.34px",
    viewBox: "0 0 800 515.34",
    enableBackground: "new 0 0 800 515.34",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\r\n    #smokeopacity {\r\n      -webkit-animation: smokeopacity 1s linear both 1 1s;\r\n      animation: smokeopacity 1s linear both 1 1s;\r\n      opacity: 0;\r\n    }\r\n    -webkit-keyframes smokeopacity {\r\n      0% {\r\n        opacity: 0;\r\n      }\r\n      50% {\r\n        opacity: 0.5;\r\n      }\r\n      100% {\r\n        opacity: 1;\r\n      }\r\n    }\r\n    @-webkit-keyframes smokeopacity {\r\n      0% {\r\n        opacity: 0;\r\n      }\r\n      50% {\r\n        opacity: 0.5;\r\n      }\r\n      100% {\r\n        opacity: 1;\r\n      }\r\n    }\r\n    @keyframes smokeopacity {\r\n      0% {\r\n        opacity: 0;\r\n      }\r\n      50% {\r\n        opacity: 0.5;\r\n      }\r\n      100% {\r\n        opacity: 1;\r\n      }\r\n    }\r\n    #smoke {\r\n      -webkit-transform: translate3d(0,0,0);\r\n      transform: translate3d(0,0,0);\r\n      -webkit-backface-visibility: hidden;\r\n      backface-visibility: hidden;\r\n      -webkit-perspective: 1000px;\r\n      perspective: 1000px;\r\n      -webkit-animation: shake 10s linear both infinite 1s;\r\n      animation: shake 10s linear both infinite 1s;\r\n    }\r\n    @-webkit-keyframes shake {\r\n      10%,\r\n      90% {\r\n        -webkit-transform: translate3d(0px,0,0);\r\n        transform: translate3d(0px,0,0);\r\n      }\r\n      20%,\r\n      80% {\r\n        -webkit-transform: translate3d(2px,0,0);\r\n        transform: translate3d(2px,0,0);\r\n      }\r\n      30%,\r\n      50%,\r\n      70% {\r\n        -webkit-transform: translate3d(-6px,0,0);\r\n        transform: translate3d(-6px,0,0);\r\n      }\r\n      40%,\r\n      60% {\r\n        -webkit-transform: translate3d(6px,0,0);\r\n        transform: translate3d(6px,0,0);\r\n      }\r\n    }\r\n    @keyframes shake {\r\n      10%,\r\n      90% {\r\n        -webkit-transform: translate3d(0px,0,0);\r\n        transform: translate3d(0px,0,0);\r\n      }\r\n      20%,\r\n      80% {\r\n        -webkit-transform: translate3d(2px,0,0);\r\n        transform: translate3d(2px,0,0);\r\n      }\r\n      30%,\r\n      50%,\r\n      70% {\r\n        -webkit-transform: translate3d(-6px,0,0);\r\n        transform: translate3d(-6px,0,0);\r\n      }\r\n      40%,\r\n      60% {\r\n        -webkit-transform: translate3d(6px,0,0);\r\n        transform: translate3d(6px,0,0);\r\n      }\r\n    }\r\n    #rocket {\r\n      -ms-transform: translateY(0) scale(1);\r\n      -webkit-transform: translateY(0) scale(1);\r\n      transform: translateY(0) scale(1);\r\n      -webkit-transform-origin: 500px 100%;\r\n      -ms-transform-origin: 500px 100%;\r\n      transform-origin: 500px 100%;\r\n      -webkit-animation: smallrocket 2s linear;\r\n      animation: smallrocket 2s linear;\r\n    }\r\n    @-webkit-keyframes smallrocket {\r\n      0% {\r\n        -ms-transform: translateY(40%) scale(0);\r\n        -webkit-transform: translateY(40%) scale(0);\r\n        transform: translateY(40%) scale(0);\r\n        opacity: 1;\r\n      }\r\n      20% {\r\n        -ms-transform: translateY(30%) scale(1);\r\n        -webkit-transform: translateY(5%) scale(1);\r\n        transform: translateY(5%) scale(1);\r\n        opacity: 1;\r\n      }\r\n      50% {\r\n        -ms-transform: translateY(5%) scale(1);\r\n        -webkit-transform: translateY(5%) scale(1);\r\n        transform: translateY(5%) scale(1);\r\n        opacity: 1;\r\n      }\r\n      100% {\r\n        -ms-transform: translateY(0) scale(1);\r\n        -webkit-transform: translateY(0) scale(1);\r\n        transform: translateY(0) scale(1);\r\n      }\r\n    }\r\n    @keyframes smallrocket {\r\n      0% {\r\n        -ms-transform: translateY(40%) scale(0);\r\n        -webkit-transform: translateY(40%) scale(0);\r\n        transform: translateY(40%) scale(0);\r\n        opacity: 0;\r\n      }\r\n      20% {\r\n        -ms-transform: translateY(30%) scale(0.5);\r\n        -webkit-transform: translateY(30%) scale(0.5);\r\n        transform: translateY(30%) scale(0.5);\r\n        opacity: 0;\r\n      }\r\n      50% {\r\n        -ms-transform: translateY(10%) scale(0.6);\r\n        -webkit-transform: translateY(10%) scale(0.6);\r\n        transform: translateY(10%) scale(0.6);\r\n        opacity: 0;\r\n      }\r\n      75% {\r\n        -ms-transform: translateY(7%) scale(0.8);\r\n        -webkit-transform: translateY(7%) scale(0.8);\r\n        transform: translateY(7%) scale(0.8);\r\n        opacity: 1;\r\n      }\r\n      100% {\r\n        -ms-transform: translateY(0) scale(1);\r\n        -webkit-transform: translateY(0) scale(1);\r\n        transform: translateY(0) scale(1);\r\n        -webkit-transform-origin: center;\r\n        transform-origin: center;\r\n      }\r\n    }\r\n    #shake-rckt {\r\n      -webkit-animation: rcktshake 1.2s linear infinite 1s;\r\n      animation: rcktshake 1.2s linear infinite 1s;\r\n    }\r\n    @-webkit-keyframes rcktshake {\r\n      0% {\r\n        -webkit-transform: translate(0px, 0px);\r\n      }\r\n      10% {\r\n        -webkit-transform: translate(-0.5px, 0px);\r\n      }\r\n      20% {\r\n        -webkit-transform: translate(0px, 0px);\r\n      }\r\n      30% {\r\n        -webkit-transform: translate(0.5px, 0px);\r\n      }\r\n      40% {\r\n        -webkit-transform: translate(0px, 0px);\r\n      }\r\n      50% {\r\n        -webkit-transform: translate(-0.5px, 0px);\r\n      }\r\n      60% {\r\n        -webkit-transform: translate(0px, 0px);\r\n      }\r\n      70% {\r\n        -webkit-transform: translate(0.5px, 0px);\r\n      }\r\n      80% {\r\n        -webkit-transform: translate(0px, 0px);\r\n      }\r\n      90% {\r\n        -webkit-transform: translate(-0.5px, 0px);\r\n      }\r\n      100% {\r\n        -webkit-transform: translate(0px, 0px);\r\n      }\r\n    }\r\n    @keyframes rcktshake {\r\n      0% {\r\n        -webkit-transform: translate(0px, 0px);\r\n      }\r\n      10% {\r\n        -webkit-transform: translate(-0.5px, 0px);\r\n      }\r\n      20% {\r\n        -webkit-transform: translate(0px, 0px);\r\n      }\r\n      30% {\r\n        -webkit-transform: translate(0.5px, 0px);\r\n      }\r\n      40% {\r\n        -webkit-transform: translate(0px, 0px);\r\n      }\r\n      50% {\r\n        -webkit-transform: translate(-0.5px, 0px);\r\n      }\r\n      60% {\r\n        -webkit-transform: translate(0px, 0px);\r\n      }\r\n      70% {\r\n        -webkit-transform: translate(0.5px, 0px);\r\n      }\r\n      80% {\r\n        -webkit-transform: translate(0px, 0px);\r\n      }\r\n      90% {\r\n        -webkit-transform: translate(-0.5px, 0px);\r\n      }\r\n      100% {\r\n        -webkit-transform: translate(0px, 0px);\r\n      }\r\n    }\r\n    #star {\r\n      opacity: 0;\r\n      margin:30px 0 0 0;\r\n      -webkit-transform-origin: center;\r\n      -ms-transform-origin: center;\r\n      transform-origin: center;\r\n      -webkit-animation: glow 3s linear infinite 2s;\r\n      animation: glow 3s linear infinite 2s;\r\n    }\r\n    @-webkit-keyframes glow {\r\n      0% {\r\n        -ms-transform: translateY(56px);\r\n        -webkit-transform: translateY(56px);\r\n        transform: translateY(56px);\r\n        opacity: 1;\r\n      }\r\n      100% {\r\n        -ms-transform: translateY(40%);\r\n        -webkit-transform: translateY(40%);\r\n        transform: translateY(40%);\r\n        opacity: 0;\r\n      }\r\n    }\r\n    @keyframes glow {\r\n      0% {\r\n        -ms-transform: translateY(56px);\r\n        -webkit-transform: translateY(56px);\r\n        transform: translateY(56px);\r\n        opacity: 1;\r\n      }\r\n      100% {\r\n        -ms-transform: translateY(40%);\r\n        -webkit-transform: translateY(40%);\r\n        transform: translateY(40%);\r\n        opacity: 0;\r\n      }\r\n    }\r\n    .clouds path:first-child {\r\n      -webkit-transform-origin: center;\r\n      -ms-transform-origin: center;\r\n      transform-origin: center;\r\n      -webkit-animation: cloudslide 10s infinite linear 2s;\r\n      animation: cloudslide 10s infinite linear 2s;\r\n      opacity: 0;\r\n    }\r\n    @-webkit-keyframes cloudslide {\r\n      0% {\r\n        -ms-transform: translateX(0);\r\n        -webkit-transform: translateX(0);\r\n        transform: translateX(0);\r\n        opacity: 1;\r\n      }\r\n      50% {\r\n        -ms-transform: translateX(240px);\r\n        -webkit-transform: translateX(-240px);\r\n        transform: translateX(240px);\r\n        opacity: 1;\r\n      }\r\n      75% {\r\n        -ms-transform: translateX(300px);\r\n        -webkit-transform: translateX(300px);\r\n        transform: translateX(300px);\r\n        opacity: 0;\r\n      }\r\n      100% {\r\n        -ms-transform: translateX(0);\r\n        -webkit-transform: translateX(0);\r\n        transform: translateX(0);\r\n        opacity: 0;\r\n      }\r\n    }\r\n    @keyframes cloudslide {\r\n      0% {\r\n        -ms-transform: translateX(0);\r\n        -webkit-transform: translateX(0);\r\n        transform: translateX(0);\r\n        opacity: 1;\r\n      }\r\n      50% {\r\n        -ms-transform: translateX(240px);\r\n        -webkit-transform: translateX(-240px);\r\n        transform: translateX(240px);\r\n        opacity: 1;\r\n      }\r\n      75% {\r\n        -ms-transform: translateX(300px);\r\n        -webkit-transform: translateX(300px);\r\n        transform: translateX(300px);\r\n        opacity: 0;\r\n      }\r\n      100% {\r\n        -ms-transform: translateX(0);\r\n        -webkit-transform: translateX(0);\r\n        transform: translateX(0);\r\n        opacity: 0;\r\n      }\r\n    }\r\n    .clouds path:nth-child(2) {\r\n      -webkit-animation: scndcloud 20s infinite linear 5s;\r\n      animation: scndcloud 20s infinite linear 5s;\r\n      opacity: 0;\r\n    }\r\n    @-webkit-keyframes scndcloud {\r\n      0% {\r\n        -ms-transform: translate(0, 50px);\r\n        -webkit-transform: translate(0, 50px);\r\n        transform: translate(0, 50px);\r\n        opacity: 0;\r\n      }\r\n      25% {\r\n        -ms-transform: translate(-225px, 50px);\r\n        -webkit-transform: translate(-225px, 50px);\r\n        transform: translate(-225px, 50px);\r\n        opacity: 1;\r\n      }\r\n      50% {\r\n        -ms-transform: translate(-400px, 50px);\r\n        -webkit-transform: translate(-400px, 50px);\r\n        transform: translate(-400px, 50px);\r\n        opacity: 1\r\n        }\r\n        75% {\r\n          -ms-transform: translate(-480px, 50px);\r\n          -webkit-transform: translate(-480px, 50px);\r\n          transform: translate(-480px, 50px);\r\n          opacity: 0;\r\n        }\r\n        100% {\r\n          -ms-transform: translate(0, 50px);\r\n          -webkit-transform: translate(0, 50px);\r\n          transform: translate(0, 50px);\r\n          opacity: 0;\r\n        }\r\n      }\r\n      @keyframes scndcloud {\r\n        0% {\r\n          -ms-transform: translate(0, 50px);\r\n          -webkit-transform: translate(0, 50px);\r\n          transform: translate(0, 50px);\r\n          opacity: 0;\r\n        }\r\n        25% {\r\n          -ms-transform: translate(-225px, 50px);\r\n          -webkit-transform: translate(-225px, 50px);\r\n          transform: translate(-225px, 50px);\r\n          opacity: 1;\r\n        }\r\n        50% {\r\n          -ms-transform: translate(-400px, 50px);\r\n          -webkit-transform: translate(-400px, 50px);\r\n          transform: translate(-400px, 50px);\r\n          opacity: 1;\r\n        }\r\n        75% {\r\n          -ms-transform: translate(-480px, 50px);\r\n          -webkit-transform: translate(-480px, 50px);\r\n          transform: translate(-480px, 50px);\r\n          opacity: 0;\r\n        }\r\n        100% {\r\n          -ms-transform: translate(0, 50px);\r\n          -webkit-transform: translate(0, 50px);\r\n          transform: translate(0, 50px);\r\n          opacity: 0;\r\n        }\r\n      }\r\n      .clouds path:nth-child(3) {\r\n        -webkit-animation: trdcld 20s infinite linear 1s;\r\n        animation: trdcld 20s infinite linear 1s;\r\n        opacity: 0;\r\n      }\r\n      @-webkit-keyframes trdcld {\r\n        0% {\r\n          -ms-transform: translateX(0);\r\n          -webkit-transform: translateX(0);\r\n          transform: translateX(0);\r\n          opacity: 0;\r\n        }\r\n        50% {\r\n          -ms-transform: translateX(-420px);\r\n          -webkit-transform: translateX(-420px);\r\n          transform: translateX(-420px);\r\n          opacity: 1;\r\n        }\r\n        75% {\r\n          -ms-transform: translateX(-480px);\r\n          -webkit-transform: translateX(-480px);\r\n          transform: translateX(-480px);\r\n          opacity: 0;\r\n        }\r\n        100% {\r\n          -ms-transform: translateX(0);\r\n          -webkit-transform: translateX(0);\r\n          transform: translateX(0);\r\n          opacity: 0;\r\n        }\r\n      }\r\n      @keyframes trdcld {\r\n        0% {\r\n          -ms-transform: translateX(0);\r\n          -webkit-transform: translateX(0);\r\n          transform: translateX(0);\r\n          opacity: 1;\r\n        }\r\n        50% {\r\n          -ms-transform: translateX(-420px);\r\n          -webkit-transform: translateX(-420px);\r\n          transform: translateX(-420px);\r\n          opacity: 1;\r\n        }\r\n        75% {\r\n          -ms-transform: translateX(-480px);\r\n          -webkit-transform: translateX(-480px);\r\n          transform: translateX(-480px);\r\n          opacity: 0;\r\n        }\r\n        100% {\r\n          -ms-transform: translateX(0);\r\n          -webkit-transform: translateX(0);\r\n          transform: translateX(0);\r\n          opacity: 0;\r\n        }\r\n      }\r\n  ")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 61.736,
    y: 473.604,
    width: 676.528,
    height: 25.637
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 61.736,
    y: 473.604,
    width: 676.528,
    height: 25.637,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 61.736,
    y: 473.604,
    width: 676.528,
    height: 25.637
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 61.736,
    y: 473.604,
    width: 676.528,
    height: 25.637,
    id: "SVGID_1_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 820.9102,
    cy: -23352.0117,
    r: 172.1242,
    gradientTransform: "matrix(2.1505 0 0 0.069 -1365.3651 2097.7107)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0851,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    style: {
      stopColor: "#DBDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4141,
    style: {
      stopColor: "#AFAFAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6333,
    style: {
      stopColor: "#747474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8784,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    mask: "url(#SVGID_1_)",
    fill: "url(#SVGID_2_)",
    d: "M738.264,486.129c0,7.081-121.11,13.111-341.669,13.111      c-220.56,0-334.858-5.732-334.858-12.813c0-7.081,114.299-12.824,334.858-12.824      C617.153,473.604,738.264,479.05,738.264,486.129z"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 820.9102,
    cy: -23352.0117,
    r: 172.1242,
    gradientTransform: "matrix(2.1505 0 0 0.069 -1365.3651 2097.7107)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "url(#SVGID_3_)",
    d: "M738.264,486.129c0,7.081-121.11,13.111-341.669,13.111  c-220.56,0-334.858-5.732-334.858-12.813c0-7.081,114.299-12.824,334.858-12.824C617.153,473.604,738.264,479.05,738.264,486.129z  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.2661,
    y1: 462.001,
    x2: 403.2661,
    y2: 35.2192
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9A9A9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0936,
    style: {
      stopColor: "#A2A2A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2383,
    style: {
      stopColor: "#B8B8B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    style: {
      stopColor: "#DBDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    style: {
      stopColor: "#E2E2E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C5C5C5"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M707.737,35.219H98.832c-10.911,0-19.756,8.725-19.756,19.488v407.294h2.82V51.917        c0-0.861,0.068-1.709,0.198-2.533c0.041-0.276,0.091-0.548,0.147-0.819c0.056-0.271,0.117-0.539,0.189-0.803        c0.071-0.269,0.146-0.534,0.227-0.791c0.704-2.222,1.862-4.236,3.367-5.952c0.172-0.203,0.356-0.398,0.542-0.588        c0.092-0.097,0.188-0.192,0.287-0.289c0.86-0.848,1.813-1.608,2.837-2.257c0.349-0.216,0.697-0.422,1.058-0.612        c0.356-0.195,0.723-0.375,1.097-0.54c0,0,0-0.003,0.004-0.003c0.247-0.11,0.503-0.209,0.753-0.311c0,0,0-0.003,0.003-0.003        c1.915-0.743,4.008-1.155,6.187-1.155h608.906c2.905,0,5.655,0.729,8.05,2.013c0.355,0.189,0.709,0.396,1.047,0.612        c0.461,0.289,0.896,0.6,1.33,0.928c0.003,0.004,0.003,0.004,0.003,0.004c0.204,0.163,0.416,0.334,0.621,0.504        c0.004,0,0.004,0,0.004,0.004c0.31,0.266,0.6,0.536,0.891,0.817c0.099,0.097,0.189,0.192,0.274,0.289        c0.191,0.19,0.376,0.386,0.554,0.588c2.562,2.921,4.116,6.736,4.116,10.898v410.084h2.87V53.481        C726.817,43.289,718.235,35.219,707.737,35.219z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.2456,
    y1: 54.7065,
    x2: 403.2456,
    y2: 32.4316
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#404040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2805,
    style: {
      stopColor: "#434343"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4483,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5865,
    style: {
      stopColor: "#595959"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7086,
    style: {
      stopColor: "#6D6D6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8201,
    style: {
      stopColor: "#888888"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    style: {
      stopColor: "#A7A7A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C5C5C5"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M79.034,51.92c0-10.76,8.846-19.488,19.756-19.488h608.906c10.911,0,19.76,8.729,19.76,19.488        v1.56c-0.639-10.191-9.221-18.261-19.719-18.261H98.832c-10.911,0-19.756,8.725-19.756,19.488L79.034,51.92z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.895,
    y: 450.603,
    width: 642.691,
    height: 11.398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.586,52.012v398.591H81.894V52.012c0-9.237,7.581-16.754,16.896-16.754h608.906          C717.01,35.258,724.586,42.774,724.586,52.012z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "727.456,462.001 727.456,463.048 724.586,463.048 724.586,463.044 81.895,463.044 81.895,463.048          79.075,463.048 79.075,462.001  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 469.7021,
    x2: 400,
    y2: 469.7021
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#929292"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0139,
    style: {
      stopColor: "#C1C1C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0271,
    style: {
      stopColor: "#B2B2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0487,
    style: {
      stopColor: "#9C9C9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0715,
    style: {
      stopColor: "#A4A4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0909,
    style: {
      stopColor: "#AFAFAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CFCFCF"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 463.648,
    fill: "url(#SVGID_6_)",
    width: 400,
    height: 12.107
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 463.3477,
    x2: 800,
    y2: 463.3477
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0055,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0639,
    style: {
      stopColor: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5025,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8664,
    style: {
      stopColor: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8755,
    style: {
      stopColor: "#D3D3D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9512,
    style: {
      stopColor: "#E9E9E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1F1F1"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 463.048,
    fill: "url(#SVGID_7_)",
    width: 800,
    height: 0.601
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 400,
    y1: 469.7021,
    x2: 800,
    y2: 469.7021
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFCFCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#AFAFAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9285,
    style: {
      stopColor: "#A4A4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9513,
    style: {
      stopColor: "#9C9C9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9729,
    style: {
      stopColor: "#B2B2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9861,
    style: {
      stopColor: "#C1C1C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#929292"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 463.648,
    fill: "url(#SVGID_8_)",
    width: 400,
    height: 12.107
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 469.3438,
    x2: 400,
    y2: 469.3438
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#666666"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0139,
    style: {
      stopColor: "#D5D5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0213,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    style: {
      stopColor: "#868686"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0487,
    style: {
      stopColor: "#707070"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572,
    style: {
      stopColor: "#787878"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0705,
    style: {
      stopColor: "#8E8E8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0867,
    style: {
      stopColor: "#B2B2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0909,
    style: {
      stopColor: "#BCBCBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1F1F1"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 463.648,
    fill: "url(#SVGID_9_)",
    width: 400,
    height: 11.392
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 400,
    y1: 469.3438,
    x2: 800,
    y2: 469.3438
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1F1F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#BCBCBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9133,
    style: {
      stopColor: "#B2B2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9295,
    style: {
      stopColor: "#8E8E8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    style: {
      stopColor: "#787878"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9513,
    style: {
      stopColor: "#707070"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    style: {
      stopColor: "#868686"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9787,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9861,
    style: {
      stopColor: "#D5D5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666666"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 463.648,
    fill: "url(#SVGID_10_)",
    width: 400,
    height: 11.392
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.0684,
    y1: 467.6855,
    x2: 456.9316,
    y2: 467.6855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9F9F9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    style: {
      stopColor: "#ACACAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    style: {
      stopColor: "#E5E5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9628,
    style: {
      stopColor: "#ACACAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9F9F9F"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M456.932,463.051c0,2.561-1.035,4.879-2.715,6.547c-1.674,1.678-3.985,2.722-6.554,2.722          h-95.334c-5.117,0-9.261-4.157-9.261-9.269H456.932z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_2_",
    filterUnits: "userSpaceOnUse",
    x: 342.618,
    y: 463.051,
    width: 114.761,
    height: 9.951
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 342.618,
    y: 463.051,
    width: 114.761,
    height: 9.951,
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter_2_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_3_",
    filterUnits: "userSpaceOnUse",
    x: 342.618,
    y: 463.051,
    width: 114.761,
    height: 9.951
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 342.618,
    y: 463.051,
    width: 114.761,
    height: 9.951,
    id: "SVGID_12_"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.6182,
    y1: 468.0264,
    x2: 457.3789,
    y2: 468.0264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00041222,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5247,
    style: {
      stopColor: "#B3B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7671,
    style: {
      stopColor: "#B5B5B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    style: {
      stopColor: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    mask: "url(#SVGID_12_)",
    fill: "url(#SVGID_13_)",
    d: "M456.936,463.051c0,2.561-1.035,4.879-2.715,6.547              c-1.674,1.678-3.984,2.722-6.554,2.722h-95.334c-5.116,0-9.261-4.157-9.261-9.269h-0.454v0.689              c0,5.111,4.153,9.262,9.27,9.262h96.22c5.129,0,9.271-4.15,9.271-9.262v-0.689H456.936z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.6182,
    y1: 468.0264,
    x2: 457.3789,
    y2: 468.0264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00041222,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5247,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7F7F7"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M456.936,463.051c0,2.561-1.035,4.879-2.715,6.547c-1.674,1.678-3.984,2.722-6.554,2.722          h-95.334c-5.116,0-9.261-4.157-9.261-9.269h-0.454v0.689c0,5.111,4.153,9.262,9.27,9.262h96.22          c5.129,0,9.271-4.15,9.271-9.262v-0.689H456.936z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.0005,
    y1: 486.4277,
    x2: 400.0005,
    y2: 475.7559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#575757"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    style: {
      stopColor: "#B9B9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8472,
    style: {
      stopColor: "#B6B6B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9363,
    style: {
      stopColor: "#ACACAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9F9F9F"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M0,475.756c28.127,7.076,57.421,10.672,86.888,10.672H400h313.112        c29.472,0,58.761-3.596,86.888-10.672H400H0z"
  })))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "space",
    x: 95.19,
    y: 59.536,
    fill: "#EDF5FF",
    width: 616.109,
    height: 381.202
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_16_",
    x: 181.648,
    width: 547.663,
    height: 557.916
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_17_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_16_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    className: "clouds"
  }, /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#FFFFFF",
    d: "M360.969,210.589c2.91-2.652,5.998-2.182,7.598-1.654  c1.408-3.621,4.432-7.744,10.93-7.744c11.578,0,12.505,11.388,12.505,11.388c8.153-2.467,9.728,4.746,9.728,5.032h-43.816  C357.913,212.961,360.969,210.589,360.969,210.589"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#FFFFFF",
    d: "M581.642,231.479c2.12,0,4.104,0.572,5.83,1.568 c3.292-5.74,9.369-9.608,16.339-9.608c6.514,0,12.252,3.363,15.667,8.485c1.801-6.17,7.379-10.671,13.986-10.671 c7.502,0,13.673,5.797,14.505,13.253c0.605-0.096,1.218-0.162,1.845-0.162c4.576,0,8.542,2.649,10.534,6.531H570.07 C571.303,235.49,576.012,231.479,581.642,231.479"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#FFFFFF",
    d: "M581.642,231.479c2.12,0,4.104,0.572,5.83,1.568  c3.292-5.74,9.369-9.608,16.339-9.608c6.514,0,12.252,3.363,15.667,8.485c1.801-6.17,7.379-10.671,13.986-10.671  c7.502,0,13.673,5.797,14.505,13.253c0.605-0.096,1.218-0.162,1.845-0.162c4.576,0,8.542,2.649,10.534,6.531H570.07  C571.303,235.49,576.012,231.479,581.642,231.479"
  })), /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#EBF5FF",
    d: "M530.176,9.235c0,3.445-2.792,6.237-6.236,6.237s-6.238-2.792-6.238-6.237  S520.495,3,523.939,3S530.176,5.791,530.176,9.235"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#84B4FE",
    d: "M386.827,139.535c0,2.305-1.868,4.17-4.174,4.17  c-2.306,0-4.171-1.866-4.171-4.17s1.865-4.171,4.171-4.171C384.959,135.364,386.827,137.23,386.827,139.535"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#EBF5FF",
    d: "M553.646,114.602l-2.499-1.341c-0.16-0.085-0.285-0.212-0.369-0.369  l-1.342-2.5c-0.337-0.631-1.246-0.631-1.586,0l-1.34,2.5c-0.086,0.157-0.209,0.284-0.366,0.369l-2.501,1.341  c-0.631,0.339-0.631,1.245,0,1.585l2.501,1.342c0.157,0.081,0.28,0.21,0.366,0.365l1.34,2.501c0.34,0.631,1.249,0.631,1.586,0  l1.342-2.501c0.084-0.155,0.209-0.285,0.369-0.365l2.499-1.342C554.279,115.847,554.279,114.94,553.646,114.602"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#C1DDF7",
    d: "M406.316,33.947l-3.15-1.689c-0.197-0.107-0.36-0.267-0.465-0.463  l-1.687-3.152c-0.429-0.797-1.572-0.797-2,0l-1.69,3.152c-0.103,0.196-0.266,0.356-0.462,0.463l-3.152,1.689  c-0.797,0.427-0.797,1.569,0,1.999l3.152,1.69c0.196,0.105,0.359,0.266,0.462,0.463l1.69,3.151c0.428,0.795,1.571,0.795,2,0  l1.687-3.151c0.105-0.197,0.268-0.357,0.465-0.463l3.15-1.69C407.114,35.517,407.114,34.375,406.316,33.947"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#C1DDF7",
    d: "M624.911,98.235l-3.811-2.044c-0.238-0.125-0.431-0.323-0.562-0.561  l-2.043-3.811c-0.517-0.963-1.898-0.963-2.415,0l-2.043,3.811c-0.128,0.237-0.325,0.436-0.559,0.561l-3.811,2.044  c-0.965,0.516-0.965,1.899,0,2.416l3.811,2.043c0.233,0.127,0.431,0.323,0.559,0.561l2.043,3.812c0.517,0.962,1.898,0.962,2.415,0  l2.043-3.812c0.131-0.238,0.323-0.433,0.562-0.561l3.811-2.043C625.872,100.134,625.872,98.75,624.911,98.235"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#84B4FE",
    d: "M327.908,83.562l-3.489-1.87c-0.218-0.118-0.396-0.295-0.513-0.514  l-1.873-3.489c-0.472-0.882-1.738-0.882-2.211,0l-1.869,3.489c-0.119,0.218-0.296,0.396-0.514,0.514l-3.487,1.87  c-0.884,0.474-0.884,1.738,0,2.213l3.487,1.87c0.218,0.117,0.396,0.296,0.514,0.516l1.869,3.487c0.474,0.882,1.74,0.882,2.211,0  l1.873-3.487c0.117-0.22,0.295-0.399,0.513-0.516l3.489-1.87C328.791,85.299,328.791,84.036,327.908,83.562"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#84B4FE",
    d: "M560.88,60.812l-2.553-1.37c-0.159-0.086-0.29-0.216-0.376-0.375l-1.37-2.552  c-0.346-0.647-1.272-0.647-1.617,0l-1.37,2.552c-0.088,0.159-0.215,0.288-0.376,0.375l-2.556,1.37  c-0.641,0.346-0.641,1.272,0,1.619l2.556,1.37c0.161,0.086,0.288,0.216,0.376,0.374l1.37,2.553c0.345,0.648,1.271,0.648,1.617,0  l1.37-2.553c0.086-0.158,0.217-0.288,0.376-0.374l2.553-1.37C561.525,62.084,561.525,61.158,560.88,60.812"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rocket"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shake-rckt"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rocketwhite",
    x: 453.475,
    y: 242.181,
    clipPath: "url(#SVGID_17_)",
    fill: "#FFFFFF",
    width: 36.358,
    height: 170.759
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#EBF5FF",
    d: "M485.543,251.934c0-7.344-5.951-13.296-13.291-13.296    c-7.346,0-13.297,5.952-13.297,13.296c0,0-1.718,31.436,13.297,48.173C487.262,283.37,485.543,251.934,485.543,251.934"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#92B2FA",
    d: "M425.816,179.936c0,0-49.789,24.112-30.063,95.219    c0,0,10.537-35.747,44.318-45.002L425.816,179.936z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#92B2FA",
    d: "M519.131,179.936c0,0,49.792,24.112,30.063,95.219    c0,0-10.532-35.747-44.313-45.002L519.131,179.936z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#334A7E",
    d: "M488.63,244.982h-33.841c-1.335,0-2.491-0.925-2.785-2.228l-1.861-8.193    c-0.402-1.786,0.957-3.491,2.79-3.491h37.558c1.831,0,3.193,1.705,2.786,3.491l-1.855,8.193    C491.125,244.057,489.966,244.982,488.63,244.982"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#C8DCF6",
    d: "M422.871,160.727c0,0,5.193,47.691,21.248,77.911c0,0,25.498-12.276,55.718,0    c0,0,18.417-25.499,22.195-81.688c2.173-32.377-0.425-69.344-11.147-101.193h-74.896    C426.02,81.702,418.922,116.542,422.871,160.727"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#334A7E",
    d: "M466.454,4.082c-7.535,8.524-22.463,29.05-31.874,55.455h77.532    c-6.288-20.655-18.274-42.449-32.684-56.084C475.719-0.059,469.84,0.255,466.454,4.082"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#92B2FA",
    d: "M471.143,158.423c0,0-22.971,52.2,0,114.267    C471.143,272.689,496.67,220.896,471.143,158.423"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#334A7E",
    d: "M502.187,109.986c0,15.958-12.94,28.896-28.898,28.896    c-15.962,0-28.897-12.938-28.897-28.896c0-15.959,12.936-28.898,28.897-28.898C489.246,81.088,502.187,94.026,502.187,109.986"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#F3D279",
    d: "M493.348,109.986c0,11.079-8.98,20.063-20.06,20.063    s-20.061-8.984-20.061-20.063c0-11.081,8.981-20.061,20.061-20.061S493.348,98.905,493.348,109.986"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "smoke"
  }, /*#__PURE__*/React.createElement("g", {
    id: "smokeopacity"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_18_",
    x: 181.648,
    y: 334.562,
    width: 547.659,
    height: 105.998
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_19_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_18_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_19_)",
    fill: "#FFFFFF",
    d: "M464.063,427.255c0,23.032-18.938,41.703-42.302,41.703  c-23.363,0-42.303-18.671-42.303-41.703c0-23.034,18.939-41.703,42.303-41.703C445.126,385.552,464.063,404.221,464.063,427.255"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_19_)",
    fill: "#FFFFFF",
    d: "M589.055,427.255c0,20.634-16.969,37.359-37.897,37.359  c-20.925,0-37.896-16.726-37.896-37.359c0-20.636,16.971-37.362,37.896-37.362C572.086,389.893,589.055,406.619,589.055,427.255"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_19_)",
    fill: "#FFFFFF",
    d: "M518.279,394.877c0,16.136-13.263,29.214-29.628,29.214  c-16.369,0-29.636-13.078-29.636-29.214c0-16.132,13.267-29.215,29.636-29.215C505.017,365.662,518.279,378.745,518.279,394.877"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_19_)",
    fill: "#FFFFFF",
    d: "M455.296,377.158c0,11.239-9.241,20.352-20.646,20.352  c-11.399,0-20.644-9.112-20.644-20.352c0-11.243,9.244-20.356,20.644-20.356C446.055,356.802,455.296,365.915,455.296,377.158"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_19_)",
    fill: "#FFFFFF",
    d: "M501.387,360.346c0,7.679-6.313,13.904-14.102,13.904  c-7.792,0-14.107-6.226-14.107-13.904c0-7.684,6.315-13.91,14.107-13.91C495.074,346.436,501.387,352.662,501.387,360.346"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_19_)",
    fill: "#FFFFFF",
    d: "M487.2,394.559c0,13.609-11.192,24.644-24.997,24.644  c-13.807,0-24.997-11.034-24.997-24.644c0-13.611,11.19-24.646,24.997-24.646C476.008,369.913,487.2,380.947,487.2,394.559"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_19_)",
    fill: "#FFFFFF",
    d: "M338.318,500.055c-5.881,41.21-44.529,69.912-86.326,64.116  c-41.801-5.797-70.917-43.903-65.034-85.111c5.88-41.206,44.528-69.91,86.327-64.117  C315.084,420.741,344.201,458.847,338.318,500.055"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_19_)",
    fill: "#FFFFFF",
    d: "M411.646,444.037c1.317,31.175-23.248,57.499-54.868,58.798  c-31.62,1.301-58.322-22.92-59.641-54.094c-1.315-31.175,23.25-57.503,54.871-58.8  C383.629,388.645,410.329,412.861,411.646,444.037"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_19_)",
    fill: "#FFFFFF",
    d: "M715.646,484.832c0,44.104-36.266,79.858-81,79.858  s-80.997-35.754-80.997-79.858c0-44.103,36.263-79.856,80.997-79.856S715.646,440.729,715.646,484.832"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_19_)",
    fill: "#FFFFFF",
    d: "M491.078,466.123c0,31.205-25.655,56.495-57.302,56.495  c-31.648,0-57.302-25.29-57.302-56.495c0-31.202,25.654-56.493,57.302-56.493C465.423,409.63,491.078,434.921,491.078,466.123"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_19_)",
    fill: "#FFFFFF",
    d: "M565.65,445.987c7.356,34.316-14.9,68.009-49.702,75.261  c-34.806,7.25-68.984-14.691-76.341-49.006c-7.354-34.313,14.902-68.008,49.707-75.261  C524.12,389.735,558.299,411.672,565.65,445.987"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#42759A",
    d: "M204.688,213.583h-8.946l24.39,68.945l13.653-39.02l-10.586-29.926h-9.439v-6.568h41.799v6.568h-9.788  l24.39,68.945l8.767-25.056c11.501-32.098-9.426-42.096-9.426-49.26c0-7.163,5.807-12.971,12.972-12.971  c0.385,0,0.763,0.02,1.131,0.056c-12.138-11.459-28.503-18.485-46.513-18.485c-23.531,0-44.259,11.994-56.409,30.202h24.004  L204.688,213.583L204.688,213.583L204.688,213.583z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42759A",
    d: "M169.318,244.587c0,25.95,14.585,48.485,36,59.874l-30.584-86.457  C171.25,226.167,169.318,235.152,169.318,244.587z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42759A",
    d: "M296.077,211.19c0.969,5.708,0.675,12.124-0.812,18.563h0.269l-1.024,2.929l0,0  c-0.608,2.115-1.374,4.278-2.241,6.402l-23.321,65.333c21.371-11.402,35.918-33.916,35.918-59.831  C304.867,232.443,301.67,221.049,296.077,211.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42759A",
    d: "M216.19,309.072c6.584,2.132,13.608,3.287,20.902,3.287c6.958,0,13.671-1.047,19.99-2.998l-19.825-56.039  L216.19,309.072z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42759A",
    d: "M294.368,187.313c-15.298-15.3-35.64-23.725-57.276-23.725s-41.977,8.425-57.275,23.725  c-15.3,15.297-23.725,35.638-23.725,57.275c0,21.638,8.425,41.976,23.725,57.275c15.298,15.3,35.64,23.726,57.275,23.726  c21.637,0,41.978-8.426,57.276-23.726c15.3-15.299,23.724-35.639,23.724-57.275C318.093,222.95,309.669,202.61,294.368,187.313z   M237.092,319.873c-41.513,0-75.286-33.772-75.286-75.286s33.773-75.286,75.286-75.286s75.286,33.773,75.286,75.286  S278.606,319.873,237.092,319.873z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpressRocket);
export default __webpack_public_path__ + "static/media/wordpress-rocket.bd9a6bd69a470f40e338129481d23284.svg";
export { ForwardRef as ReactComponent };